<div [ngClass]="{ 'show-border': showBorder }" class="pt-4 pb-4 side-padding">

  <div class="flex items-center">
    @if (showBack()) {
      <mat-icon (click)="onBackClick()" class="mr-4 cursor-pointer">arrow_back</mat-icon>
    }
    <h2 [innerHTML]="title | translate | nl2br" class="text-2xl max-w-[24ch]"></h2>
    <mat-icon (click)="onClose()" class="ml-auto cursor-pointer">close</mat-icon>
  </div>
  <p *ngIf="subTitle"
     [innerHTML]="subTitle | translate | nl2br"
     class="text-md font-light mt-2 primary-sublabel">
  </p>
  <ng-content></ng-content>
</div>
